import type { GenericLayer, LayerType, SelectionHandler } from "../../types";

import { SiteDetailHeader } from "./SiteDetailHeader";
import { SiteRightClickMenu } from "./SitesRightClickMenu";
import { SitesControlPage } from "./ControlPage";
import { SitesMapLayer } from "./MapLayer";
import { SitesSelectionReportSummary } from "./SitesSelectionReportSummary";
import { SitesSelectionSidebar } from "./SitesSelectionSidebar";
import { landAssemblyClickResolver } from "../../selectionUtils";
import { sharedSiteSelectionResolver } from "./sharedSiteSelectionResolver";
import { siteSelectionResolver } from "./siteSelectionResolver";
import { sitesClickResolver } from "./sitesClickResolver";

export type SitesLayer = GenericLayer<{
  captureInternalPolygonClicks?: boolean;
}>;

export const SitesLayerType: LayerType = {
  id: "sites",
  SelectionSidebar: SitesSelectionSidebar,
  MapLayer: SitesMapLayer,
  clickResolver: sitesClickResolver,
  RightClickMenu: SiteRightClickMenu,
  landAssemblyClickResolver: landAssemblyClickResolver(sitesClickResolver),
  ControlPage: SitesControlPage,
};

export const SitesSelectionHandler: SelectionHandler = {
  SelectionHeader: SiteDetailHeader,
  selectionResolver: siteSelectionResolver,
  SelectionPrintableSummary: SitesSelectionReportSummary,
};

export const SharedSitesSelectionHandler: SelectionHandler = {
  SelectionHeader: SiteDetailHeader,
  selectionResolver: sharedSiteSelectionResolver,
  SelectionPrintableSummary: SitesSelectionReportSummary,
};
